module.exports = __webpack_public_path__ + "static/media/cross.816943a2.png";